import { useMutation } from '@tanstack/react-query';

import { USER_QUERY_KEY } from 'src/features/auth/utils';
import { type MutationConfig, queryClient } from 'src/lib/react-query';
import { storage } from 'src/utils/storage';

type ActionFnType = () => Promise<() => void>;

// Deletes the token from the storage and redirects to the home page.
interface UseMutationOptions extends MutationConfig<ActionFnType> {}
const useMutationHook = (options: UseMutationOptions = {}) =>
    useMutation({
        mutationFn: async () => {
            return Promise.resolve(() => {
                storage.clear();
            });
        },
        ...options,
        onSuccess: (user, ...rest) => {
            queryClient.setQueryData([USER_QUERY_KEY], user);
            options?.onSuccess?.(user, ...rest);
        },
    });

export { useMutationHook as useLogout };
